<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                chemicalPurchaseForm: () => import('../forms/ChemicalPurchaseForm'),
                loadForm: () => import('../forms/LoadForm'),
                fields: [
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Load', value: 'loadId', rules: [v => !!v || 'Load is required'], isRequired: true, form: () => import('./LoadForm'), apiMethod: 'Loads', claim: 'Loads' },
                    { type: 'autocomplete', text: 'Chemical Purchase', value: 'chemicalPurchaseId', rules: [v => !!v || 'Chemical Purchase is required'], isRequired: true, form: () => import('./ChemicalPurchaseForm'), apiMethod: 'ChemicalPurchases', claim: 'ChemicalPurchases' },
                    { type: 'number', text: 'Number Of Hives', value: 'numberOfHives', rules: [v => (v !== null && v !== '') || 'Number Of Hives is required'], isRequired: true },
                ],
                apiMethod: 'Treatments',
                formTitle: 'Treatment',
            }
        },
    };
</script>
